import React, { Component } from 'react'
import { organisationImgUpload } from '../../../_actions/organisations/orgImgUpload.action';
import { connect } from 'react-redux';
import '../Form2/index.css';
import './index.css';
import uploadImage from '../../../images/Bodhi_Icon_UploadLogo.png';
import addImage from '../../../images/addImage.png';
import removeImage from '../../../images/removeImage.png';
import swal from 'sweetalert2/dist/sweetalert2.min.js';

class DetailsPanel2 extends Component {

    constructor(props) {
        super(props)
        this.state = {
            orgImg: this.props.orgImg
        }
    }

    imageUploadDiv = () => {
        this.myinput.click()
    }

    imageUpload = (e) => {
        const { id, dispatch } = this.props;
        if (this.state.orgImg === uploadImage) {
            const imgFile = {
                id,
                file: e.target.files[0]
            };
            dispatch(organisationImgUpload.postImgUpload(imgFile));
        } else {
            swal({
                text: 'Are you sure you want to remove the organization image?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
            }).then((result) => {
                if (result.value) {
                    let data = {
                        organisation: this.props.id
                    };
                    dispatch(organisationImgUpload.removeImgUpload(data));
                }
            });
        }
    }

    componentDidMount() {
        const props = this.props;
        const that = this;
        const baseLink = localStorage.getItem('baseLink');

        props.imgSrc.map((val, key) => {
            if (val.id == this.props.id) {
                if (val.organisation_image !== null && val.organisation_image !== '') {
                    that.setState({
                        orgImg: baseLink + '/media/' + val.organisation_image
                    })
                } else {
                    that.setState({
                        orgImg: uploadImage
                    })
                }
            }
        })
    }
    componentDidUpdate(prevProps) {
        if (prevProps.orgUploadLoading !== this.props.orgUploadLoading) {
         
            if (!this.props.orgUploadError && !this.props.orgUploadLoading) {
           
                swal({
                    title: 'Success',
                    text: 'Image uploaded!',
                    type: 'success',
                    confirmButtonText: 'OK',
                });
            } else if (!this.props.orgUploadLoading && this.props.orgUploadError) {
                let errorMessage;
                const statusCode = this.props.orgUploadError.status ? this.props.orgUploadError.status : null;
                const errorData = this.props.orgUploadError.data ? this.props.orgUploadError.data : null;

                switch (statusCode) {
                    case 400:
                        errorMessage = errorData && errorData.message && errorData.message.organisation_image
                            ? errorData.message.organisation_image[0]
                            : 'Image size should be 200px*200px.';
                        break;
                    case 406:
                        errorMessage = "Invalid file format! Please upload either JPEG JPG or PNG.";
                        break;
                    default:
                        errorMessage = 'An error occurred while uploading the image.';
                }

                swal({
                    title: 'Error',
                    text: errorMessage,
                    type: 'error',
                    confirmButtonText: 'OK',
                });
            }
        }








        if (prevProps.orgRemoveLoading !== this.props.orgRemoveLoading) {
            if (!this.props.orgRemoveError && !this.props.orgRemoveLoading) {
                swal({
                    title: 'Success',
                    text: 'Image deleted successfully!',
                    type: 'success',
                    confirmButtonText: 'OK',
                });
            } else if (!this.props.orgRemoveLoading && this.props.orgRemoveError) {
                swal({
                    title: 'Error',
                    text: 'Image deletion failed!',
                    type: 'error',
                    confirmButtonText: 'OK',
                });
            }
        }
    }


    render() {
        const props = this.props;
        const state = this.state;
        const baseLink = localStorage.getItem('baseLink');
     
        const { orgUploadError, orgUploadLoading } = this.props;
      

        return (
            <div key={props.key} className="media border-top-0" style={{ background: 'rgb(245, 245, 245)' }}>
                <div className="media-body p-3">
                    <p className="mb-2">
                        <strong className=""> {props.heading} </strong>
                    </p>
                    <p className="text-capitalize" style={{ margin: 0 }}>Seller: {props.data.Seller}</p>
                    <p className="text-capitalize" style={{ margin: 0 }}>{props.data.Address}</p>
                    <p className="text-capitalize" style={{ margin: 0 }}>{props.data.City}</p>
                    <p className="text-capitalize" style={{ margin: 0 }}>{props.data.Pincode}</p>
                    <p className="text-capitalize" style={{ margin: 0 }}>{props.data.State}</p>
                    <p className="text-capitalize" style={{ margin: 0 }}>{props.data.Country}</p>
                </div>
                <div className="detailUpload" style={{ padding: 10 }} onClick={this.imageUploadDiv}>
                    <img width={"100px"} className={"detailUpload-first-image"} src={this.state.orgImg === '' ? localStorage.getItem('baseLink') + `/${props.state.orgImageUpload.orgUploadSuccess.data.image_path}` : this.state.orgImg} alt="Generic placeholder image" />
                    <img style={{ cursor: 'pointer' }} onClick={this.state.orgImg !== uploadImage ? (e) => this.imageUpload(e) : () => {}} src={this.state.orgImg === uploadImage ? addImage : removeImage} />
                    <input readOnly onChange={this.imageUpload} ref={(input) => this.myinput = input} type={this.state.orgImg === uploadImage ? "file" : "hidden"} />
                    {
                        props.orgImageLoad === true &&
                        <i className="fas fa-spinner uploadLoader"></i>
                    }
                    {
                        props.orgUploadError === true &&
                        <div className="errorDiv">
                            <i className="fas fa-exclamation-triangle errorTrigangle"></i>
                            <p>Max Upload Size 200px</p>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {

    //get org list for edit form fill
    const orgError = state.organisation.error;
    const orgLoading = state.organisation.loading;
    const organisationList = (!orgError && !orgLoading) ? state.organisation.organisation.data.organisation_list : [];

    const { orgUploadLoading, orgUploadError } = state.orgImageUpload;
    const { orgRemoveLoading, orgRemoveError } = state.orgImageRemove;



    const imgSrc = (!orgError && !orgLoading) ? state.organisation.organisation.data.organisation_list : '';

    const orgImageLoad = state.orgImageUpload.orgImageLoad;
    return {
        state,
        imgSrc,
        orgUploadError,
        orgUploadLoading,
        orgRemoveLoading, orgRemoveError,
        orgImageLoad
    }
}

export default connect(mapStateToProps)(DetailsPanel2);



// WEBPACK FOOTER //
// ./src/_components/common/TableNew/details2.jsx